import { ExcalidrawElement } from "@excalidraw/excalidraw/types/element/types"
import { AppState } from "@excalidraw/excalidraw/types/types"

export enum HldStages {
  TestInstructions = "test_instructions",
  InterviewSetup = "interview_setup",
  FunctionalRequirementGathering = "functional_requirement_gathering",
  NonFunctionalRequirementGathering = "non_functional_requirement_gathering",
  EstimationOfScale = "estimation_of_scale",
  ApiDesign = "api_design",
  SystemDesign = "system_design",
  Continuation = "continuation",
  Completed = "completed",
  Disqualification = "disqualification",
}

export interface ExcalidrawState {
  elements: readonly ExcalidrawElement[]
  appState: Partial<AppState>
}
